import React from "react";
import { Helmet } from "react-helmet";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { endOfTitle } from "../../../constants/constants";
import {
  SERVICE_TYPE_ICONS,
  SERVICE_TYPE_LABEL_MAP,
  SERVICE_TYPE_NAME_MAP,
} from "../constants";
import { useParams } from "react-router";
import FontIcon from "../../../components/FontIcon";
import useServicesQueries from "../hooks/useServicesQueries";
import { useQuery } from "react-query";
import CategoryServiceList from "../components/CategoryServiceList";
import Loading from "../../../components/Loading";
import { IServiceByProvider } from "../types";

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: "2rem",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  subjectsListContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
}));

const CategoryServiceListPage = () => {
  const classes = useStyles();

  const params: { categoryName: string } = useParams();
  const { categoryName } = params;
  const categoryId = SERVICE_TYPE_NAME_MAP[categoryName];

  const { getServiceListByCategory } = useServicesQueries();

  const {
    isLoading,
    data,
  }: { isLoading: boolean; data: { data: IServiceByProvider[] } } =
    useQuery<any>(`category_${categoryId}`, () =>
      getServiceListByCategory(categoryName),
    );

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>Category Service List{endOfTitle}</title>
      </Helmet>
      <Container maxWidth="lg">
        <h1 className={classes.header}>
          <FontIcon
            name={SERVICE_TYPE_ICONS[categoryId]}
            style={{ fontSize: 18, marginRight: 8 }}
          />
          {SERVICE_TYPE_LABEL_MAP[categoryId]}
        </h1>
        <CategoryServiceList list={data.data} />
      </Container>
    </>
  );
};

export default React.memo(CategoryServiceListPage);
